import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class RecalculateBalanceCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(bank_account_id:string, transaction_ids:string[]): Promise<any> {
    let args: any = { 
      bank_account_id: bank_account_id,
      transaction_ids: transaction_ids
    }

    this.frontend.recalculateBalanceLoading = true;
    let res = await this.dispatcher.dispatch('recalculate.balance', args);
    if (res.output && res.output['success']) {
      this.frontend.genericInformationDialogMsg = "Saldo recalculado correctamente.";
    } else {
      this.frontend.genericInformationDialogMsg = "Error al recalcular el saldo.";
    }
    this.frontend.showGenericInformationDialog = true
    this.frontend.recalculateBalanceLoading = false;
  }
}